import { Component } from 'react';

import PropTypes from 'prop-types';

export default class GenericFetch extends Component {
  componentDidMount() {
    const { endpoint, preventFetch, onStart } = this.props;
    if (preventFetch) return;
    if (onStart) {
      onStart(endpoint);
    }
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    const { endpoint, refetch, preventFetch, onStart } = this.props;
    if (preventFetch) return;

    if (
      (prevProps.refetch !== refetch && refetch)
         || (prevProps.endpoint !== endpoint)
         || (prevProps.preventFetch !== preventFetch && refetch)
    ) {
      if (onStart) {
        onStart(endpoint);
      }
      this.fetchData();
    }
  }

  fetchData() {
    const { endpoint, success, error } = this.props;
    const onSuccess = success || function () {};
    const onError = error || function () {};

    fetch(endpoint, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(resp => {
        if (resp.url.includes('login')) throw new Error('login failed');
        if (!resp.ok) throw new Error(`HTTP error! status: ${resp.status}`);
        return resp.json();
      })
      .then(onSuccess)
      .catch(onError);
  }

  render() {
    return null;
  }
}

GenericFetch.propTypes = {
  refetch: PropTypes.bool,
  preventFetch: PropTypes.bool,
  endpoint: PropTypes.string.isRequired,
  success: PropTypes.func,
  error: PropTypes.func,
};
